import { render, staticRenderFns } from "./LikertTypeActive.vue?vue&type=template&id=7b9e18fa&scoped=true&"
import script from "./LikertTypeActive.vue?vue&type=script&lang=js&"
export * from "./LikertTypeActive.vue?vue&type=script&lang=js&"
import style0 from "./LikertTypeActive.vue?vue&type=style&index=0&id=7b9e18fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9e18fa",
  null
  
)

export default component.exports